import React, { Component, useEffect } from "react";
import { connect } from "react-redux";

import Settings from "../../components/Settings";
import SignInContainer from "../SignInContainer";

const SettingsContainer = (props) => {
  if (props.user) {
    return <Settings user={props.user} taxes={props.taxes} />;
  } else {
    return <SignInContainer />;
  }
};

const mapStateToProps = (state) => ({
  user: state.user,
  taxes: state.taxes,
});

export default connect(mapStateToProps)(SettingsContainer);
